export const trackOpenAILead = () => {
    if (typeof window === 'undefined') return;

    if (typeof window.oaiq !== 'function') return;

    window.oaiq(
        'measure',
        'appointment_scheduled',
        { type: 'customer_action' }
    );
};